import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const saveWellnessAssessment = async (payload) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/wellness-assessment`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "Error saving wellness assessment:",
            error.response?.data || error.message
        );

        throw error;
    }
};

export const getWellnessAssessments = async (userId) => {

    try {

        const response = await axios.get(
            `${API_BASE_URL}/wellness-assessment/${userId}`
        );

        return response.data;

    } catch (error) {

        console.error(
            "Error fetching wellness assessments:",
            error.response?.data || error.message
        );

        throw error;
    }
};